import angles, { defaultViewAngleId as id } from '~c/viewAngles'

const viewAngles = angles
const defaultViewAngleId = id

export default viewAngles
export { defaultViewAngleId }
